function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white px-6 py-12">
      <div className="max-w-4xl mx-auto">

        <h1 className="text-4xl font-extrabold mb-6">About NestQuest</h1>

        <p className="text-lg text-slate-200 mb-6">
         NestQuest Technologies Limited is certified according to the Zambia Companies Act and operates in accordance with 
         relevant laws and regulations, ensuring the highest standards of quality and integrity. Our commitment to compliance 
         and certification underscores our dedication to excellence and customer satisfaction.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4 text-white">What Sets Us Apart</h2>
        <p>NestQuest is poised to capture a significant share of the growing rental market, with a focus on:</p>
        <ul className="list-disc list-inside space-y-2 text-slate-200">
          <li>Young professionals and students: Seeking convenient and affordable rental options that meet their lifestyle needs.</li>
          <li>Families: Looking for suitable accommodation with ease, prioritizing comfort, safety, and convenience.</li>
          <li>Landlords: Wanting to advertise their properties efficiently, maximizing visibility and rental income.</li>
          <li>Business personnel: Seeking office spaces that meet their needs, prioritizing functionality, accessibility, and productivity.</li>
        </ul>

        <h2 className="text-3xl font-extrabold mt-12 mb-6">Meet Our Team</h2>

        <div className="grid gap-8 md:grid-cols-3">
          {/* CEO */}
          <div className="bg-white text-gray-800 rounded-lg shadow-lg p-6 text-center">
            <img
              src="/moses_chileshe.jpg"
              alt="Moses Chileshe"
              className="rounded-full mx-auto mb-4 object-cover shadow"
            />
            <h3 className="text-xl font-semibold">Moses Chileshe</h3>
            <p className="text-sm text-gray-600 mb-2">Human Resource Manager</p>
            <p className="text-sm text-gray-700">
              Moses is a dedicated Human Resource Manager at NestQuest, responsible for overseeing employee relations, talent development, and organizational culture.
            </p>
          </div>

          {/* Software Developer */}
          <div className="bg-white text-gray-800 rounded-lg shadow-lg p-6 text-center">
            <img
              src="/aubrey.jpg"
              alt="Aubrey Chilambwe"
              className="rounded-full mx-auto mb-4 object-cover shadow"
            />
            <h3 className="text-xl font-semibold">Aubrey Chilambwe</h3>
            <p className="text-sm text-gray-600 mb-2">Software Developer</p>
            <p className="text-sm text-gray-700">
              Aubrey leads the technical development of the NestQuest platform, ensuring speed, reliability, and user-focused features.
            </p>
          </div>

          {/* Finance Manager */}
          <div className="bg-white text-gray-800 rounded-lg shadow-lg p-6 text-center">
            <img
              src="/chiko.jpg"
              alt="Chiko Mwiinga"
              className="rounded-full mx-auto mb-4 object-cover shadow"
            />
            <h3 className="text-xl font-semibold">Chiko Mwiinga</h3>
            <p className="text-sm text-gray-600 mb-2">Finance & Accounting Manager</p>
            <p className="text-sm text-gray-700">
              Chiko oversees the company’s finances and budgeting, ensuring sustainable growth and responsible spending.
            </p>
          </div>
        </div>

        <div className="mt-10">
          <p className="text-lg text-slate-300">
           We invite investors, partners, and users to join us in shaping the future of rental property search. Together, 
           let's create a more efficient, secure, and user-friendly experience for all. With NestQuest, the future of rental property search is brighter than ever.
          </p>
        </div>

      </div>
    </div>
  );
}

export default About;
